<script setup lang="ts">
// Vendor
import type { Entry } from "contentful";

defineProps<{
  content?: Entry[];
  heroContent?: Entry["fields"] | null;
  heroContentType?: string;
}>();
</script>

<template>
  <div>
    <div :class="['hero-wrapper', { container: heroContentType !== 'hero' }]">
      <ContentfulSection
        v-if="heroContent"
        :container="false"
        :content="heroContent"
      />
    </div>

    <div class="mt56 mb56" v-if="content?.length">
      <template v-for="contentEntry in content" :key="contentEntry.sys.id">
        <ContentfulSection
          v-if="contentEntry.sys?.contentType?.sys.id === 'section'"
          container
          :content="contentEntry"
          :content-type="contentEntry?.sys.contentType?.sys.id"
        />
        <ContentfulMissingComponent v-else />
      </template>
    </div>
  </div>
</template>
